/**
 * @file Constants relating to Dates.
 */

export const DATE_FORMAT_WITH_TIME = 'MMMM Do YY, h:mm a';
export const SHORT_DATE_FORMAT_WITH_TIME = 'MMM D, Y \\at h:mm A';
export const DATE_FORMAT_SIMPLE = 'DD MMMM YY';
export const DATE_FORMAT_SHORT = 'MM/DD/YY';

export const DATE_OFFSET_TYPE = {
  DAYS_BEFORE_EVENT: 'DAYS_BEFORE_EVENT',
  DAYS_AFTER_EVENT: 'DAYS_AFTER_EVENT',
  DAYS_AFTER_EVENT_START: 'DAYS_AFTER_EVENT_START',
  DAYS_AFTER_FIRST_PHOTO_PUBLISH: 'DAYS_AFTER_FIRST_PHOTO_PUBLISH',
  DAYS_AFTER_FIRST_MATCH: 'DAYS_AFTER_FIRST_MATCH',
  SCHEDULED_AT: 'SCHEDULED_AT',
  // This is a client side only type.
  DAY_OF_THE_EVENT: 'DAY_OF_THE_EVENT',
};
